import React from 'react';
import PropTypes from 'prop-types';
import MultipleChoiceQuestion from '../components/MultipleChoiceQuestion';

const answerOptions = [
  {id: 1, label: '0 to 7 years'},
  {id: 2, label: '8 to 16 years'},
  {id: 3, label: '17 to 21 years'},
  {id: 4, label: '22 to 59 years'},
  {id: 5, label: '60+ years'},
];

const ParticipantAgeQuestion = ({data, handleAnswer}) => {
  return (
    <MultipleChoiceQuestion
      question="How old is the person who needs the service?"
      item="age_group"
      data={data}
      answerOptions={answerOptions}
      handleAnswer={handleAnswer}
    />
  );
};

ParticipantAgeQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ParticipantAgeQuestion;
